// Cave84 — useValuationBasis hook
// Thin wrapper around valuationBasis.store, matching the usePrivacy split.
//
// Usage: const { basis, setBasis, toggle } = useValuationBasis();

import { useValuationBasisStore, type ValuationBasis } from '@/stores/valuationBasis.store';

export interface UseValuationBasisResult {
  basis: ValuationBasis;
  setBasis: (basis: ValuationBasis) => void;
  toggle: () => void;
}

export function useValuationBasis(): UseValuationBasisResult {
  const basis = useValuationBasisStore((s) => s.basis);
  const setBasis = useValuationBasisStore((s) => s.setBasis);
  const toggle = useValuationBasisStore((s) => s.toggle);
  return { basis, setBasis, toggle };
}
